(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDialogController', FeasibilityCheckDialogController);

    FeasibilityCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FeasibilityCheck'];

    function FeasibilityCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FeasibilityCheck) {
        var vm = this;
        $scope.EMAIL_REGEXP = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
		$scope.PHONE_REGEXP = /^[0-9]+$/;
        vm.feasibilityCheck = entity;
        vm.clear = clear;
        vm.save = save;
        vm.feasibilityCheck.notificationType = "SMS";
       // vm.users = User.query();
       // vm.tenants = Tenant.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.feasibilityCheck.id !== null) {
                FeasibilityCheck.update(vm.feasibilityCheck, onSaveSuccess, onSaveError);
            } else {
                FeasibilityCheck.save(vm.feasibilityCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:feasibilityCheckUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
